import { useMutation, useQueryClient } from '@tanstack/react-query';
import { planPaymentRequestApi } from '@src/apis/admin';

/**
 * 결제 요청 취소 mutation
 *
 * @description
 * - 진행 중인 결제 요청을 취소합니다.
 * - PlanPaymentRequestApi.cancelPaymentRequest를 사용하여 실제 API를 호출합니다.
 * - 성공 시 관련 쿼리들을 무효화하여 데이터를 갱신합니다.
 */
export const useCancelPaymentRequest = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['cancelPaymentRequest'],
        mutationFn: async ({
            channelId,
            paymentRequestId,
        }: {
            channelId: string;
            paymentRequestId: string;
        }) => {
            const { data } = await planPaymentRequestApi.cancelPaymentRequest(
                channelId,
                paymentRequestId,
                undefined // x-rwd-api-version은 default value 사용
            );

            return { data, channelId };
        },
        onSuccess: (response) => {
            // 관련 쿼리 무효화하여 재조회 유도
            queryClient.invalidateQueries({ queryKey: ['current-payment-request', response.channelId] });
            queryClient.invalidateQueries({ queryKey: ['plan-history', response.channelId] });
            queryClient.invalidateQueries({ queryKey: ['channel-detail', response.channelId] });
            queryClient.invalidateQueries({ queryKey: ['channels'] });
        },
    });
};

